const { ConsentName } = require('./consentName');

const PERMISSION_COOKIE = 'ck';
const PERMISSION_MARKETING = 'mr';

const activePermissions = [PERMISSION_COOKIE, PERMISSION_MARKETING];

const permissionsConsent = {
  [PERMISSION_COOKIE]: ConsentName.AnalyticsStorage,
  [PERMISSION_MARKETING]: ConsentName.AdStorage
};

module.exports = { PERMISSION_COOKIE, PERMISSION_MARKETING, activePermissions, permissionsConsent };
